var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.498,
    height: 21.498,
    viewBox: "0 0 21.498 21.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cancel",
    "data-name": "Icon metro-cancel",
    d: "M13.32,1.928A10.749,10.749,0,1,0,24.069,12.677,10.749,10.749,0,0,0,13.32,1.928Zm0,19.483a8.734,8.734,0,1,1,8.734-8.734A8.734,8.734,0,0,1,13.32,21.411ZM16.679,7.3,13.32,10.662,9.961,7.3,7.945,9.318,11.3,12.677,7.945,16.036l2.015,2.015,3.359-3.359,3.359,3.359,2.015-2.015-3.359-3.359,3.359-3.359Z",
    transform: "translate(-2.57 -1.928)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.90ffe4a56408d13ff082c309c1e63bec.svg";
export { ForwardRef as ReactComponent };